export default 'https://n.dyar.cn/web/index.php'
